<template>
  <el-select
    v-model="valueBackup"
    placeholder="请选择课程介绍视频"
    :style="width ? `width: ${width}` : ''"
    :clearable="true"
  >
    <v-avatar-option
      :value="list"
      :ratio="1.78"
      radius="5px"
      avatar-key="cover"
      name-key="course_video_name"
    />
  </el-select>
</template>

<script>
import { index } from '@/api/course-video';

export default {
  props: {
    value: [Number, String],
    width: String,
  },
  data: () => ({
    valueBackup: '',
    list: [],
  }),
  watch: {
    value(value) {
      if (value === this.valueBackup) return;
      this.valueBackup = +value || '';
    },
    valueBackup(valueBackup) {
      if (valueBackup === (+this.value || '')) return;
      this.$emit('input', valueBackup);
    },
  },
  methods: {
    async getList() {
      const { isError, data } = await index({ is_all: 1 });
      if (!isError) this.list = data;
    },
  },
  beforeMount() {
    this.valueBackup = +this.value || '';
    this.getList();
  },
};
</script>
